import React, { createContext } from 'react';
import ToastService from '../utils/toast';


export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const toastService = ToastService();

  return (
    <ToastContext.Provider value={toastService}>
      {children}
      {toastService.ToastComponent}
    </ToastContext.Provider>
  );
};
